module.exports = __webpack_public_path__ + "img/comportamiento.c1661f07.svg";